import { get, post } from "./base.js";

const PricingRuleServ = {
    getAll: () => {
        return get("/pricing-rules");
    },

    upsert: (payload) => {
        return post("/pricing-rules", payload);
    },

    getApplied: (params) => {
        const query = new URLSearchParams(params).toString();
        return get(`/pricing-rules/applied?${query}`);
    }
};

export default PricingRuleServ;
